import { Button, Result, Row, Spin, Typography, UploadProps } from "antd";
import Dragger from "antd/lib/upload/Dragger";
import { InboxOutlined } from '@ant-design/icons';
import React, { useState } from "react";

const props: UploadProps = {
    name: 'file',
    multiple: false,
    showUploadList: false,
    onDrop(e) {
        console.log('Dropped files', e.dataTransfer.files);
    },
};

export function ImportCompetitors() {

    const [uploading, setUploading] = useState<boolean>(false)
    const [result, setResult] = useState<boolean | null>(null)
    const [errorMessage, setErrorMessage] = useState<string>("")

    return (
        <>
            <Typography.Title style={{ marginTop: '20px' }} level={5}>Fichier de fournisseurs</Typography.Title>
            <Dragger
                disabled={uploading}
                {...props}
                onChange={(info) => {
                    const { status } = info.file;
                    if (status == 'uploading') {
                        setUploading(true)
                    }
                    if (status === 'done') {
                        setUploading(false)
                        setResult(true)
                        console.log(`${info.file.name} file uploaded successfully.`);
                    } else if (status === 'error') {
                        setUploading(false)
                        setResult(false)
                        setErrorMessage(info.file.response)
                        console.error(`${info.file.name} file upload failed.`);
                    }
                }}
                style={{ cursor: 'pointer', marginTop: '20px', padding: '20px', border: 'solid 1px #1890ff', borderRadius: '20px', width: '250px' }}
                action={document.location.origin + '/cnegoces/uploadCompetitorsFile'}
            >
                <InboxOutlined style={{ fontSize: 50, width: '100%', color: "#1890ff" }} />
                <br />
                <br />
                <Typography.Text style={{ textAlign: 'center' }}>Cliquez ou déposez votre fichier</Typography.Text>
            </Dragger >
            {uploading && (
                <Row style={{ marginTop: '50px' }}><Spin /><Typography.Title level={2}>Enregistrement en cours ...</Typography.Title></Row>
            )}
            {result != null && (
                <Result
                    status={result ? "success" : "error"}
                    title={result ? "L'enregistrement est réussi !" : "Une Erreur est survenue..."}
                    subTitle={result ? "" : errorMessage}
                    extra={[
                        <Button type="primary" onClick={() => setResult(null)}>
                            J'ai compris
                        </Button>,
                    ]}
                />
            )}
        </>
    )
}